
import { Vue } from 'vue-class-component';

export default class LoadingIcon extends Vue {}
